// extracted by mini-css-extract-plugin
export default {"image":"Image_image__lBVwu","noImage":"Image_noImage__S+jjJ"};